module.exports = __webpack_public_path__ + "static/img/persons-icon.686f775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/persons-icon.png
// module id = K8C8
// module chunks = 1